module.exports = __webpack_public_path__ + "static/media/map_directions_icon.6cdfb0e0.svg";